import React, { forwardRef, memo } from 'react';

import PropTypes from 'prop-types';

// No width/height attributes: the draw paths size the backing store and zero it when they
// leave the page, and React would re-apply attributes on every re-render.
const AiModelResultOverlay = forwardRef(({ onMouseMove = null }, ref) => {
  return (
    <canvas
      className="absolute top-0 left-0 h-full w-full z-10"
      ref={ref}
      onMouseMove={onMouseMove}
    />
  );
});

AiModelResultOverlay.propTypes = {
  onMouseMove: PropTypes.func,
};

export default memo(AiModelResultOverlay);
